import HttpClient from '../httpClient';
import LikeType from '../models/likeType';
import RootService from '../services/rootService';

const LikeTypesService = {

  parseLikeType: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      name: response.name,
      text: response.text,
      _links: response._links,
      _forms: response._forms
    };
  },

  parseLikeTypesList: function(response) {
    if (!response || !response._embedded || !response._embedded.item) return [];

    return response._embedded.item.map(likeTypeResponse => {
      return LikeTypesService.parseLikeType(likeTypeResponse);
    });
  },

  getLikeTypes: function() {
    return RootService.getRoot().then(root => {
      const likeTypesLink = root.getLink('dm:like_types:v1');

      return HttpClient.get(likeTypesLink.href).then(response => {
        return LikeTypesService.parseLikeTypesList(response).map(likeTypeProps => new LikeType(likeTypeProps));
      });
    });
  }

};

export default LikeTypesService;


// WEBPACK FOOTER //
// ./src/api/services/likeTypesService.js